const keyPrefix = "budgeter.defaultAccount.";

/**
 * The user's Quick Add account as last seen from the server, so an offline Quick Add (or one
 * before `GET /me` answers) still saves to the right account. `undefined` = never known.
 */
export function readStoredDefaultAccount(userId: string): string | null | undefined {
  try {
    const raw = localStorage.getItem(keyPrefix + userId);
    if (raw === null) {
      return undefined;
    }
    return (JSON.parse(raw) as { id: string | null }).id;
  } catch {
    return undefined;
  }
}

export function storeDefaultAccount(userId: string, id: string | null): void {
  try {
    localStorage.setItem(keyPrefix + userId, JSON.stringify({ id }));
  } catch {
    // Without storage Quick Add falls back to the first account while offline.
  }
}
